/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Incomplete_EyebrowInputs */

const en_us2_profile_incomplete_eyebrow = /** @type {(inputs: Profile_Incomplete_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete your profile`)
};

const pt_br2_profile_incomplete_eyebrow = /** @type {(inputs: Profile_Incomplete_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete seu perfil`)
};

const es_419_profile_incomplete_eyebrow = /** @type {(inputs: Profile_Incomplete_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa tu perfil`)
};

const pt_pt2_profile_incomplete_eyebrow = /** @type {(inputs: Profile_Incomplete_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa o teu perfil`)
};

const fr_fr2_profile_incomplete_eyebrow = /** @type {(inputs: Profile_Incomplete_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complète ton profil`)
};

const de_de2_profile_incomplete_eyebrow = /** @type {(inputs: Profile_Incomplete_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervollständige dein Profil`)
};

const it_it2_profile_incomplete_eyebrow = /** @type {(inputs: Profile_Incomplete_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa il tuo profilo`)
};

/**
* | output |
* | --- |
* | "Complete your profile" |
*
* @param {Profile_Incomplete_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_incomplete_eyebrow = /** @type {((inputs?: Profile_Incomplete_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Incomplete_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_incomplete_eyebrow(inputs)
	if (locale === "es-419") return es_419_profile_incomplete_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_incomplete_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_incomplete_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_profile_incomplete_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_profile_incomplete_eyebrow(inputs)
	return en_us2_profile_incomplete_eyebrow(inputs)
});
export { profile_incomplete_eyebrow as "profile.incomplete_eyebrow" }